const skillsdata = [
    {
        id: 1,
        name: 'HTML',
        level: 100,
    },
    {
        id: 2,
        name: 'CSS',
        level: 80,
    },
    {
        id: 3,
        name: 'JavaScript',
        level: 70,

    },
    {
        id: 4,
        name: 'React',
        level: 75,

    },
    {
        id: 5,
        name: 'Front-End Development',
        level: 85,
    },
    {
        id: 6,
        name: 'APIs',
        level: 60,
    },
    {
        id: 7,
        name: 'Docker',
        level: 50,
    },
    {
        id: 8,
        name: 'java',
        level: 50,
    },
    {
        id: 9,
        name: 'Python',
        level: 70,
    },
    {
        id: 10,
        name: 'C++',
        level: 65,
    },
    {
        id: 11,
        name: 'C',
        level: 85,
    },
    {
        id: 12,
        name: 'Git & GitHub',
        level: 70,
    },
    {
        id: 13,
        name: 'Data Structures',
        level: 70,
    },
    {
        id: 14,
        name: 'Algorithms',
        level: 70,
    },
    {
        id: 15,
        name: 'Problem Solving',
        level: 70,
    },
    {
        id: 16,
        name: 'SQL',
        level: 70,
    },
    {
        id: 17,
        name:'Project Management',
        level: 70,
    },
    {
        id: 18,
        name: 'Statistics',
        level: 65,
    },
    {
        id: 19,
        name: 'Databases',
        level: 65,
    },
    {
        id: 20,
        name: 'Teamwork',
        level: 70,
    },
    {
        id: 21,
        name: 'Communication',
        level: 75,

    },
    {
        id: 22,
        name: 'Adobe Premiere Pro',
        level: 70,
    },
  

   ];
export default skillsdata;